module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point01/th_05-a31f4d7cbc3dc287f6b99bdefbf95391.jpg";